module.exports = __webpack_public_path__ + "static/img/envelope01vi.812d11a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope01vi.png
// module id = PDry
// module chunks = 1